import { render } from "./HiNavDrawerItem.vue?vue&type=template&id=431d52a8&scoped=true"
import script from "./HiNavDrawerItem.vue?vue&type=script&lang=js"
export * from "./HiNavDrawerItem.vue?vue&type=script&lang=js"

import "./HiNavDrawerItem.vue?vue&type=style&index=0&id=431d52a8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431d52a8"]])

export default __exports__